//import REACT_APP_API_URL from "./env";

//const API_URL ="/api";
//const API_URL =process.env.REACT_APP_API_URL;//process.env.REACT_APP_API_URL;

export const API_URL = process.env.REACT_APP_API_URL || "";
export const API_UPLOAD_URL = process.env.REACT_APP_API_UPLOAD_URL || "";

//export default API_URL;
